var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":_vm.pageTitle}}),_c('iframe',{ref:"iframe",staticStyle:{"width":"100%","height":"calc(100vh - 112px)","border":"none"},attrs:{"src":_vm.iframeSrc,"title":"content"},on:{"load":_vm.onIframeLoad}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }